// extracted by mini-css-extract-plugin
export default {"appointmentModal":"Appointments_appointmentModal__piFcQ","card":"Appointments_card__PQbU8","green":"Appointments_green__FLxYR","red":"Appointments_red__eIS+a"};